import { Button } from 'src/ui/components/button/common/Button';
import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import styled from '@emotion/styled';
import { AccountNavigationLink } from 'src/domains/layouts/webview/components/accountNavigationLink/AccountNavigationLink';
import { withConfig } from 'src/withConfig';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';


export const PlaceButtonWrapper = withConfig(theme => styled(Button, { label: 'PlaceButtonWrapper' })`
    height: 48px;
    padding: 0;
    width: 100%;
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.3;
    gap: 8px;
    flex: 1 1 50%;
`);

export const FreeBetButtonWrapper = styled(PlaceButtonWrapper, { label: 'FreeBetButtonWrapper' })`
    margin-left: 2px !important;
    margin-right: 0 !important;
`;

export const AcceptChangesBtnWrapper = styled(Button, { label: 'AcceptChangesBtnWrapper' })`
    display: block;
    width: 100%;
`;

interface LogInToPlaceBetBtnWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const LogInToPlaceBetBtnWrapper = withConfig(theme => styled(AccountNavigationLink, { label: 'LogInToPlaceBetBtnWrapper' })<LogInToPlaceBetBtnWrapperPropsType>`
    border-radius: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.small : '0'};
    display: block;
    position: sticky;
    text-transform: none;
    width: 100%;
    &:only-child {
        bottom: 8px;
    }
`);

interface OpenBetsBtnWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const OpenBetsBtnWrapper = withConfig(theme => styled(Link, { label: 'OpenBetsBtnWrapper' })<OpenBetsBtnWrapperPropsType>`
    display: block;
    text-transform: none;
    line-height: ${theme.star.button.common.typography.lineHeightPrimary};
    border-radius: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.small : '0'};
`);

export const ReAddBetslipBtnWrapper = withConfig(theme => styled(Button, { label: 'ReAddBetslipBtnWrapper' })<OpenBetsBtnWrapperPropsType>`
    display: block;
    border-radius: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.small : '0'};
`);

export const ChevronIconWrapper = styled(ChevronIcon, { label: 'ChevronIconWrapper' })`
    position: absolute;
    margin: auto;
    float: left;
    top: 6px;
    width: 12px;
    fill: currentcolor;
    transition: transform .2s ease;
`;

export const HeaderWrapper = styled('li', { label: 'HeaderWrapper' })`
    position: relative;
`;

export const Label = withConfig(theme => styled('span', { label: 'Label' })`
    color: ${theme.star.betslipGeneral.txtColor};
    cursor: pointer;
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1;
    margin-left: 20px;
`);

interface MyBetsSectionPropsType {
    isMiniCasino: boolean;
}

export const BetslipMainWrapper = withConfig(theme => styled('section', { label: 'BetslipMainWrapper' }) <MyBetsSectionPropsType>`
    background-color: ${theme.star.betslipGeneral.bgColor};
    color: ${theme.star.betslipGeneral.txtColor};
    padding-bottom: ${({ isMiniCasino }): string => isMiniCasino ? '20px' : '40px'};
`);

